import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { IntegerInput } from "components/Global/FastFormikMaterial";

const StyledIntegerInput = styled(IntegerInput)`
  & {
    width: 100%;
  }
`;
class SpreadMaintenance extends React.Component {
  componentDidMount() {
    const { openPeriod } = this.props;
    this.setDescription(openPeriod);
  }

  componentDidUpdate(prevProps) {
    const { openPeriod } = this.props;
    const { openPeriod: prevOpenPeriod } = prevProps;
    if (openPeriod !== prevOpenPeriod) {
      this.setDescription(openPeriod);
    }
  }

  setDescription(openPeriod) {
    this.props.setDescription("");
  }

  render() {
    const { index } = this.props;

    return (
      <Grid item xs={4}>
        <StyledIntegerInput
          label="Open Periods"
          fieldName={`prepaymentSchedules[${index}].openPeriod`}
        />
      </Grid>
    );
  }
}
export default SpreadMaintenance;
